import * as Vec3 from 'gl-vec3';
import * as Vec2 from 'gl-vec2';

import { lerp, lerpAngle } from './lerp';

const makeSkidJumpingState = (getFloorIntersection, getWallIntersection) => {
  const initialState = {
  };
  
  const update = (state, dt, { movement, jump }) => {
    const lastPosition = state.position;
    state.position = Vec3.clone(state.position);
    state.velocity = Vec3.clone(state.velocity);
    
    // apply gravity
    state.velocity[1] -= 30 * dt;
    
    // apply accel but keep a max horizontal speed
    if (Vec2.length(movement) > 0.1) {
      const velocity2d = Vec2.fromValues(state.velocity[0], state.velocity[2]);
      const maxSpeed = Math.max(Vec2.length(velocity2d), 20);
      Vec2.scaleAndAdd(velocity2d, velocity2d, movement, 20 * dt);
      if (Vec2.length(velocity2d) > maxSpeed) {
        Vec2.normalize(velocity2d, velocity2d);
        Vec2.scale(velocity2d, velocity2d, maxSpeed);
      }

      // switch back to 3d
      state.velocity[0] = velocity2d[0];
      state.velocity[2] = velocity2d[1];
    }

    // jumping legs animation
    state.walk += state.velocity[1] * dt;
    state.walkScale = lerp(state.walkScale, Math.min(Math.max(state.velocity[1] / 10, -1), 1), 0.1, dt*60);
    
    Vec3.scaleAndAdd(state.position, state.position, state.velocity, dt);
    
    const wall = getWallIntersection(Vec3.add([], state.position, [0, 2, 0]), 0.5);
    if (wall.hit && wall.distance < 1) {
      Vec3.scaleAndAdd(state.position, state.position, wall.normal, 1-wall.distance);
      Vec3.scaleAndAdd([], state.velocity, wall.normal, -2 * Vec3.dot(state.velocity, wall.normal));
    }
    
    const floor = getFloorIntersection(state.position, 2);
    if (floor.hit) {
      state.shadowNormal = floor.normal;
      state.shadowDistance = state.position[1] - floor.hit[1];
    } else {
      state.mode = 'jumping';
      Vec3.copy(state.position, lastPosition);
    }
    
    if (state.velocity[1] <= 0) {
      state.mode = 'jumping';
    }
    
    return state;
  };
  
  return { initialState, update };
}

export default makeSkidJumpingState;